import { render } from "./AdminLoginPage.vue?vue&type=template&id=59bf7c4e&ts=true"
import script from "./AdminLoginPage.vue?vue&type=script&lang=ts"
export * from "./AdminLoginPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/richcle-kyc-fe/richcle-kyc-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__